// Shared by the recommendation tips and the scenario planner: change these once and both follow
export const MIN_GROUP_POINTS = 0.001;  // a group that can't earn points (EAP share of 0) is skipped
export const MIN_GAP = 0.01;            // gaps smaller than this aren't worth naming or planning for

// groups: [{ key, target, max_points, current }] -> same list with `gap`, biggest first
export const rankDemoGaps = (groups) => groups
    .filter((g) => (g.max_points ?? 0) >= MIN_GROUP_POINTS)
    .map((g) => {
        const target = g.target ?? 0;
        const earned = target > 0 ? Math.min(((g.current ?? 0) / target) * g.max_points, g.max_points) : 0;
        return { ...g, gap: g.max_points - earned };
    })
    .sort((a, b) => b.gap - a.gap);

// spend_summary row -> groups
export const groupsFromSpendRow = (row, demos) => (row?.map_vals ? demos.map((d) => ({
    key: d, target: row.targets?.[d], max_points: row.map_vals[d], current: row[d],
})) : []);
